<template>
    <!--結果頁面的main-area這層要+ h-auto 不然滾不動-->
    <div class="main-area" :is="page" :path="path" :show_retainer="show_retainer" v-bind:class="{'h-auto':showResult}"  @switch-component="switchComponent" @open-result="openResult" @close-result="closeResult" @share="share" @close-retainer-test="closeRetainerTest">
    </div>
</template>

<script>
import Home from "./components/Home.vue";
import FirstTest from "./components/FirstTest.vue";
import DenturesTest from "./components/DenturesTest.vue";
import MouthTest from "./components/MouthTest.vue";
import RetainerTest from "./components/RetainerTest.vue";

export default {
    name:"Home",
    data() {
        return {
            page: 'home',
            path: process.env.MIX_APP_URL+'/ben/npm/images/',
            showResult: false,
            show_retainer:true
        }
    },
    components:{
        'home'          : Home,
        'first-test'    : FirstTest,
        'dentures-test' : DenturesTest,
        'mouth-test'    : MouthTest,
        'retainer-test' : RetainerTest,
    },
    methods: {
        switchComponent: function (page) {
            this.page = page
        },
        closeRetainerTest: function () {
            this.show_retainer = false
        },
        openResult(){
            this.showResult = true
        },
        closeResult(){
            this.showResult = false
        },
        share(url) {
            if(navigator.share){
                fetch(url)
                    .then(response => response.blob())
                    .then(blob => {
                        const filename = url.split('/').pop();
                        let file = new File([blob], '影像.jpeg', { type: 'image/jpeg' });

                        navigator.share({
                            files: [file]
                        })
                    });
            }else{
                let link = document.createElement('a');

                link.href = url;
                link.download = '影像.jpeg';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    },
    created() {
    },
    mounted: function () {
    },
    watch: {
    },
    computed:{
    }
}
</script>

